import { createIdentifier } from '@wendellhu/redi';

export interface IStorageService {
  get(key: string): string | null;
  set(key: string, value: string): void;
  remove(key: string): void;
}

export const IStorageServiceToken = createIdentifier<IStorageService>('core.storage');
